import AppDispatcher from '../utils/AppDispatcher';
import { actions as ActionTypes } from '../constants/GuestConstants';
import GuestApi from '../api/GuestApi';
import * as _ from 'lodash';
import NotificationActions from './NotificationActions';

import UserStore from '../stores/UserStore';
import RoutingStore from '../stores/RoutingStore';
import GuestStore from '../stores/GuestStore';
import PosCartStore from '../stores/PosCartStore';

var GuestActions = {

    loadGuestAvatar:(guest_id) => {
        var formData      = UserStore.getApiData();
        formData.guest_id = guest_id;
        return GuestApi.loadGuestAvatar(formData);
    },

    loadFullGuest:(guest_id, clearCart = true) => {
        var formData        = UserStore.getApiData();
        formData.guest_id   = guest_id;

        if (clearCart) {
            PosCartStore.clearCart();
        }

        GuestStore.selectGuest(guest_id);
            GuestApi.loadFullGuest(formData)
            .then(res => {
            if(!res.Result) {
                let failRes = _.find(res, r => !r.Result);
                NotificationActions.error(`Failed to load guest. ${failRes.Message}`);
                AppDispatcher.dispatch({
                    actionType  : ActionTypes.GUEST_LOAD_FAIL,
                    data        : null
                });
                return;
            }

            var user = res.Data;

            if (user) {
                user.CurrentRoom = parseInt(user.CurrentRoom);
                user.CurrentRegister = parseInt(user.CurrentRegister);

                if (!user.notes)
                    user.notes = '';

                if (!user.status)
                    user.status = '';

                if (!user.doctor)
                    user.doctor = 0;

                if (!user.DOB)
                    user.DOB = '';

                if (!user.CreditNote)
                    user.CreditNote = '';

                for (var i=0; i<user.identifications.length; i++) {
                    if (!user.identifications[i].ExpirationDate)
                        user.identifications[i].ExpirationDate = '';
                }
            }

            var route = RoutingStore.getRoute();
            if (user.Errors && Array.isArray(user.Errors)) {
                for(var i = 0; i < user.Errors.length; i++) {
                    NotificationActions.error(user.Errors[i]);
                }
            }

            AppDispatcher.dispatch({
                actionType  : user ? ActionTypes.GUEST_LOADED : ActionTypes.GUEST_LOAD_FAIL,
                data        : user
            });
        }, fail => {
            NotificationActions.error('failed to load guest list');
        });
    },

    editGuestProfile(formData) {
        GuestApi.editGuestProfile(formData)
            .then(res => {
                if (res.Result) {
                    if (res.Data[0].PatientUpdated === 0) {
                        GuestActions.notification(res.Data[0].PatientResponse || 'Error', 'error')
                    } else {
                        GuestActions.notification('Patient profile updated successfully', 'success');
                        GuestActions.loadFullGuest(res.Data[0].Guest_id);
                    }
                }
                else {
                    GuestActions.notification('Patient profile update failed', 'error');
                }
            });
    },

    notification(message, type) {
        setTimeout(() => {
            NotificationActions.addNotification({
                type : type,
                body : message
            });
        }, 100);
    }
}

export default GuestActions;



// WEBPACK FOOTER //
// ./ui_src/app/actions/GuestActions.jsx